import { useTranslation } from 'react-i18next';
import { Logo } from '../../../web/src/components/navigation/logo.jsx';

/**
 * Phone-styled mockup frame: no browser chrome or desktop top menu — the
 * content sits in a rounded screen above a mobile bottom nav bar.
 * @param {{ children: import('react').ReactNode, highlightAdd?: boolean }} props
 * @returns {JSX.Element}
 */
export function MockPhoneFrame({ children, highlightAdd }) {
	const { t } = useTranslation();
	return (
		<div className="mock-phone">
			<div className="mock-phone-screen card">
				<div className="mock-phone-body">{children}</div>
				<nav className="mock-phone-nav" aria-hidden="true">
					<div className="mock-nav-btn">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
							<polyline points="9 22 9 12 15 12 15 22" />
						</svg>
						<span>{t('mobile.home')}</span>
					</div>
					<div className="mock-nav-btn">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
							<line x1="1" y1="10" x2="23" y2="10" />
						</svg>
						<span>{t('mobile.accounts')}</span>
					</div>
					<div className={`mock-nav-add${highlightAdd ? ' is-highlight' : ''}`} aria-label={t('btn.addTransaction')}>
						<Logo size={34} stroke="#fff" strokeWidth={28} />
					</div>
					<div className="mock-nav-btn">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<circle cx="12" cy="12" r="10" />
							<polyline points="12 6 12 12 16 14" />
						</svg>
						<span>{t('mobile.pending')}</span>
					</div>
					<div className="mock-nav-btn">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
							<line x1="3" y1="6" x2="21" y2="6" />
							<line x1="3" y1="12" x2="21" y2="12" />
							<line x1="3" y1="18" x2="21" y2="18" />
						</svg>
						<span>{t('mobile.menu')}</span>
					</div>
				</nav>
			</div>
		</div>
	);
}
